import { isNull, isUndefined } from "lodash";

const arraysIntersection = (arrs) =>
  arrs.reduce((a, b) => a.filter((c) => b.includes(c)));

// Constants for category filter names
export const CATEGORY_FILTER_NAMES = ['mb_category', 'mb_category.keyword'];

export function isCategoryFilter(filterName) {
  return CATEGORY_FILTER_NAMES.includes(filterName);
}

export function UpdateFilterBySubjectTo(filter, filtersCollection) {
  if (
    filter.subjectTo?.length > 0 &&
    filter.subjectTo.every((x) =>
      filtersCollection.some((filter) => filter.mbName == x),
    )
  ) {
    const effectiveType = filter.leafType ?? filter.type;
    switch (effectiveType) {
      case "CollectionDictionary": {
        const nestedValues = [];
        const result = fixSubjectTo(
          filter,
          filtersCollection,
          filter.values,
          nestedValues,
        );
        if (!result) return filter;

        if (nestedValues.length === 0) {
          filter.values = {};
          break;
        }
        // Union of all keys across parent selections
        const allKeys = [
          ...new Set(nestedValues.flatMap((x) => Object.keys(x))),
        ];
        const resultDict = {};
        for (const key of allKeys) {
          const valuesForKey = nestedValues
            .filter((x) => x[key] !== undefined)
            .flatMap((x) => (Array.isArray(x[key]) ? x[key] : [x[key]]));
          resultDict[key] = [...new Set(valuesForKey)];
        }
        filter.values = resultDict;
        break;
      }
      case "Collection":
      case "Compound": {
        if (Array.isArray(filter.values)) break; // flat array, no narrowing needed
        const nestedValues = [];
        const result = fixSubjectTo(
          filter,
          filtersCollection,
          filter.values,
          nestedValues,
        );
        if (!result) return filter;
        if (nestedValues.length === 0) {
          filter.values = [];
          break;
        }
        // Union all collected arrays
        filter.values = [...new Set(nestedValues.flat())];
        break;
      }
      default:
        break;
    }
  }
  return filter;
}

/**
 * Fix filters values which are subjected to other filters.
 *
 * @param filter - The filter.
 * @param filtersCollection - the entire filters collection
 * @param nestedDict - the current values dict to lookup value in
 * @param keepNested - the values we collected until now
 * @return true if filter values has been modified correctly and false otherwise. false is returned if no selected property
 * of a subjected to filter exists
 *
 */
function fixSubjectTo(
  filter,
  filtersCollection,
  nestedDict,
  keepNested,
  currentDepth = 0,
) {
  const maxDepth = filter.subjectTo.length;
  if (currentDepth == maxDepth) {
    keepNested.push(nestedDict);
    return true;
  }

  const subjectName = filter.subjectTo[currentDepth];
  const subjectFilter = filtersCollection.find((x) => x.mbName === subjectName);

  if (isUndefined(subjectFilter.selectedProperties)) return false;

  const selectedValues = Array.isArray(subjectFilter.selectedProperties)
    ? subjectFilter.selectedProperties
    : [subjectFilter.selectedProperties];
  for (const value of selectedValues) {
    if (isNull(nestedDict) || !nestedDict[value]) {
      keepNested = [];
      break;
    }
    fixSubjectTo(
      filter,
      filtersCollection,
      nestedDict[value],
      keepNested,
      currentDepth + 1,
    );
  }
  return true;
}

export function CategoryLeaf(category) {
  if (!category || typeof category !== 'string') return "";
  const parts = category.split(">");
  return parts.length > 0 ? parts[parts.length - 1].trim() : "";
}
